module.exports = __webpack_public_path__ + "static/media/19ESCAP44.6925dabf.jpg";